import React, {Component} from 'react';

import {SurveyFormInputEnhance} from "./SurveyFormInputEnhance";
import DateUtils from "../../../../../../monitoring/src/Utils/DateUtils";
import FormInput from "../../../../../../monitoring/src/Components/Common/FormInput";

const DISPLAY_FORMAT = "MMM d, yyyy";

@SurveyFormInputEnhance
export class SurveyFormInputDate extends Component {
    render() {
        const {Value, SurveyFormInput, EditMode} = this.props;
        const answer = SurveyFormInput.GetAnswer();

        const handleChange = (value) => {
            const formattedValue = value ? DateUtils.FormatDate(value, 'yyyy-MM-dd') : value;
            SurveyFormInput.Change(answer => {
                answer.valueDate = formattedValue;
                return answer;
            });
        }

        return EditMode ?
            <FormInput
                className="sb-survey-form-input-date"
                type="date"
                value={DateUtils.FormatDate(Value, 'yyyy-MM-dd')}
                onChange={handleChange}
                placeholder={"Pick a date"}
            />:
            <div>{answer?.valueDate ? DateUtils.FormatDate(Value, DISPLAY_FORMAT) : ""}</div>
        ;
    }
}


